import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Login.css';

function VerifyEmail() {
	const [email, setEmail] = useState('');
	const [verificationCode, setVerificationCode] = useState('');
	const [timeLeft, setTimeLeft] = useState(0);
	const [canResend, setCanResend] = useState(true);
	const [error, setError] = useState('');
	const [success, setSuccess] = useState('');
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		console.log('🎯 VerifyEmail 마운트');
		
		const tempUser = localStorage.getItem('temp_user');
		if (!tempUser) {
			alert('잘못된 접근입니다.');
			navigate('/login');
			return;
		}

		const user = JSON.parse(tempUser);
		setEmail(user.email);
		
		console.log('📧 이메일:', user.email);
		
		const alreadySent = sessionStorage.getItem('code_sent');
		if (!alreadySent) {
			handleSendCode(user.email);
			sessionStorage.setItem('code_sent', 'true');
		}
	}, []);

	useEffect(() => {
		return () => {
			sessionStorage.removeItem('code_sent');
		};
	}, []);

	useEffect(() => {
		if (timeLeft > 0) {
			const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
			return () => clearTimeout(timer);
		}
	}, [timeLeft]);

	const handleSendCode = async (targetEmail = email) => {
		if (!canResend) {
			alert('1분 후에 재전송할 수 있습니다.');
			return;
		}

		try {
			setLoading(true);
			setError('');
			
			console.log('📧 인증코드 발송:', targetEmail);
			
			const response = await axios.post(
				'https://api.weartoday.kr/api/users/send-verification-code/',
				{ email: targetEmail }
			);
			
			console.log('✅ 발송 성공:', response.data);
			
			setSuccess('인증코드가 이메일로 발송되었습니다.');
			alert('✅ 인증코드가 이메일로 발송되었습니다.');
			setTimeLeft(300);
			setCanResend(false);
			
			setTimeout(() => {
				setCanResend(true);
				setSuccess('');
			}, 60000);
			
		} catch (error) {
			console.error('❌ 인증코드 발송 실패:', error);
			const errorMsg = error.response?.data?.error || '인증코드 발송에 실패했습니다.';
			setError(errorMsg);
			alert('❌ ' + errorMsg);
		} finally {
			setLoading(false);
		}
	};

	const handleVerifyCode = async () => {
		if (!verificationCode || verificationCode.length !== 6) {
			const msg = '6자리 인증코드를 입력해주세요.';
			setError(msg);
			alert('⚠️ ' + msg);
			return;
		}

		try {
			setLoading(true);
			setError('');
			
			console.log('🔐 인증코드 확인:', verificationCode);
			
			const response = await axios.post(
				'https://api.weartoday.kr/api/users/verify-email/',
				{
					email: email,
					code: verificationCode
				}
			);
			
			console.log('✅ 인증 완료:', response.data);
			
			const tempToken = localStorage.getItem('temp_access_token');
			const tempUser = localStorage.getItem('temp_user');
			
			if (tempToken && tempUser) {
				const user = JSON.parse(tempUser);
				user.email_verified = true;
				
				localStorage.setItem('access_token', tempToken);
				localStorage.setItem('user', JSON.stringify(user));
				
				localStorage.removeItem('temp_access_token');
				localStorage.removeItem('temp_user');
			}
			
			window.dispatchEvent(new Event('loginStateChanged'));
			
			alert('✅ 이메일 인증이 완료되었습니다!');
			navigate('/');
			
		} catch (error) {
			console.error('❌ 인증 실패:', error);
			const errorMsg = error.response?.data?.message || '인증코드가 올바르지 않습니다.';
			setError(errorMsg);
			alert('❌ ' + errorMsg);
		} finally {
			setLoading(false);
		}
	};

	const handleSkip = () => {
		if (window.confirm('이메일 인증을 나중에 진행하시겠습니까?\n일부 기능이 제한될 수 있습니다.')) {
			const tempToken = localStorage.getItem('temp_access_token');
			const tempUser = localStorage.getItem('temp_user');
			
			if (tempToken && tempUser) {
				localStorage.setItem('access_token', tempToken);
				localStorage.setItem('user', tempUser);
				
				localStorage.removeItem('temp_access_token');
				localStorage.removeItem('temp_user');
			}
			
			window.dispatchEvent(new Event('loginStateChanged'));
			navigate('/');
		}
	};

	return (
		<div className="login-container">
			<div className="login-box">
				<h2>이메일 인증</h2>
				
				<p style={{ 
					padding: '15px', 
					backgroundColor: '#fff3cd', 
					border: '1px solid #ffeaa7',
					borderRadius: '8px',
					marginBottom: '20px',
					color: '#856404'
				}}>
					📧 <strong>{email}</strong>로<br/>
					인증코드가 발송되었습니다.
				</p>

				{error && (
					<div style={{
						padding: '12px',
						backgroundColor: '#f8d7da',
						border: '1px solid #f5c6cb',
						borderRadius: '8px',
						color: '#721c24',
						marginBottom: '15px',
						fontSize: '14px'
					}}>
						{error}
					</div>
				)}
				
				{success && (
					<div style={{
						padding: '12px',
						backgroundColor: '#d4edda',
						border: '1px solid #c3e6cb',
						borderRadius: '8px',
						color: '#155724',
						marginBottom: '15px',
						fontSize: '14px'
					}}>
						{success}
					</div>
				)}

				<div className="form-group">
					<label>인증코드</label>
					<input
						type="text"
						value={verificationCode}
						onChange={(e) => {
							setVerificationCode(e.target.value);
							setError('');
						}}
						placeholder="6자리 코드 입력"
						maxLength="6"
						autoComplete="one-time-code"
					/>
					<p style={{ 
						marginTop: '8px', 
						fontSize: '13px', 
						color: '#6c757d' 
					}}>
						{timeLeft > 0 ? (
							<span>⏰ {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')} 남음</span>
						) : (
							<span style={{color: 'red'}}>⚠️ 시간 만료</span>
						)}
					</p>
				</div>

				<button 
					onClick={handleVerifyCode} 
					className="btn-login"
					disabled={loading}
					style={{ marginBottom: '10px' }}
				>
					{loading ? '확인 중...' : '인증 확인'}
				</button>

				<button 
					onClick={() => handleSendCode()} 
					disabled={!canResend || loading}
					style={{ 
						width: '100%',
						padding: '12px',
						backgroundColor: canResend ? '#6c757d' : '#ccc',
						color: 'white',
						border: 'none',
						borderRadius: '8px',
						cursor: canResend ? 'pointer' : 'not-allowed',
						marginBottom: '10px',
						fontSize: '15px',
						fontWeight: '600'
					}}
				>
					{canResend ? '인증코드 재전송' : '1분 후 재전송 가능'}
				</button>

				<button 
					onClick={handleSkip}
					style={{
						width: '100%',
						padding: '12px',
						backgroundColor: 'transparent',
						color: '#6c757d',
						border: '1px solid #ddd',
						borderRadius: '8px',
						cursor: 'pointer',
						fontSize: '14px'
					}}
				>
					나중에 인증하기
				</button>
			</div>
		</div>
	);
}

export default VerifyEmail;